<template>
  <Layout style="overflow: auto; height: 100%" class="master">
    <top-warning @change-plan="handleChangePlan" @withdraw-cancellation="handleWithdrawCancellation"></top-warning>
    <Header class="header-con">
      <div class="header-bar">
        <div class="float-left">
          <Icon @click="toggleMobileMenu" :style="{ margin: '0 4px' }" class="hidden-lg-up" type="md-menu" size="24" />
        </div>

        <div class="float-left hidden-lg-down">
          <Select v-model="billingAccountId" class="account-list">
            <Option v-for="account in billingAccounts" :value="account.id" :key="account.id">{{ account.name }}</Option>
            <Option v-show="billingAccounts && isAccountCreated === false" :value="0" :key="0">+ New account</Option>
          </Select>
        </div>

        <div class="logo">
          <img src="../../images/logo-banner.png" />
        </div>

        <div class="custom-content-user float-right">
          <user :message-unread-count="unreadCount" :user-avatar="userAvatar" />
          <notice style="margin-right: 8px; cursor: pointer"></notice>
          <help class="hidden-lg-down" style="margin-right: 6px"></help>
          <fullscreen v-model="isFullscreen" class="hidden-lg-down" style="margin-right: 6px" />
        </div>
      </div>
    </Header>
    <Layout class="main-content">
      <Sider ref="leftSider" :width="78" class="left-sider hidden-lg-down" hide-trigger>
        <Menu :active-name="activeMenuName" @on-select="handleMenuSelect" :class="menuitemClasses" width="auto" style="height: calc(100% - 40px)">
          <MenuItem :to="{ name: 'dashboard' }" name="dashboard">
            <div class="menu-icon menu-icon-home" />
            <p>Home</p>
          </MenuItem>
          <MenuItem :to="{ name: 'teams' }" name="teams">
            <div class="menu-icon menu-icon-team" />
            <p>Teams</p>
          </MenuItem>
          <MenuItem :to="{ name: 'goals' }" name="goals">
            <div class="menu-icon menu-icon-goal" />
            <p>Targets</p>
          </MenuItem>
          <MenuItem :to="{ name: 'projects' }" name="projects">
            <div class="menu-icon menu-icon-project" />
            <p>Projects</p>
          </MenuItem>
          <MenuItem :to="{ name: 'reviews' }" name="reviews">
            <div class="menu-icon menu-icon-review" />
            <p>Reviews</p>
          </MenuItem>
          <MenuItem :to="{ name: 'courses' }" name="courses">
            <div class="menu-icon menu-icon-courses" />
            <p>Playbooks</p>
          </MenuItem>
          <MenuItem v-if="hasUserManagementPermission" :to="{ name: 'users' }" name="users">
            <div class="menu-icon menu-icon-users" />
            <p>Users</p>
          </MenuItem>
          <MenuItem v-if="hasAccountAdminPermission" :to="{ name: 'adminland' }" name="adminland">
            <div class="menu-icon menu-icon-admin" />
            <p>Account</p>
          </MenuItem>
        </Menu>
        <div style="text-align: center">
          <a @click="showPrivacy = true" style="color: white">Privacy</a>
          <br />
          <a @click="showTerms = true" style="color: white">Terms</a>
        </div>
      </Sider>
      <Content>
        <Drawer :closable="false" v-model="showMobileMenu" class="mobile-menu" placement="left" width="200px">
          <Menu :active-name="activeMenuName" @on-select="handleMenuSelect" class="menu-item" width="auto" style="height: calc(100% - 40px)">
            <div class="left-sider-top">
              <Select v-model="billingAccountId" class="account-list">
                <Option v-for="account in billingAccounts" :value="account.id" :key="account.id">{{ account.name }}</Option>
              </Select>
            </div>
            <MenuItem :to="{ name: 'dashboard' }" name="dashboard">
              <div class="menu-icon menu-icon-home" />
              <span>Home</span>
            </MenuItem>
            <MenuItem :to="{ name: 'teams' }" name="teams">
              <div class="menu-icon menu-icon-team" />
              <span>Teams</span>
            </MenuItem>
            <MenuItem :to="{ name: 'goals' }" name="goals">
              <div class="menu-icon menu-icon-goal" />
              <span>Targets</span>
            </MenuItem>
            <MenuItem :to="{ name: 'projects' }" name="projects">
              <div class="menu-icon menu-icon-project" />
              <span>Projects</span>
            </MenuItem>
            <MenuItem :to="{ name: 'reviews' }" name="reviews">
              <div class="menu-icon menu-icon-review" />
              <span>Reviews</span>
            </MenuItem>
            <MenuItem :to="{ name: 'courses' }" name="courses">
              <div class="menu-icon menu-icon-courses" />
              <span>Playbooks</span>
            </MenuItem>
            <MenuItem v-if="hasUserManagementPermission" :to="{ name: 'users' }" name="users">
              <div class="menu-icon menu-icon-users" />
              <span>Users</span>
            </MenuItem>
            <MenuItem v-if="hasAccountAdminPermission" :to="{ name: 'adminland' }" name="adminland">
              <div class="menu-icon menu-icon-admin" />
              <span>Account</span>
            </MenuItem>
          </Menu>
          <div style="text-align: center">
            <a @click="showPrivacy = true" style="color: white">Privacy</a>
            <span style="color: white"> | </span>
            <a @click="showTerms = true" style="color: white">Terms</a>
          </div>
        </Drawer>

        <keep-alive :include="cacheList">
          <router-view> </router-view>
        </keep-alive>
        <ABackTop :height="100" :bottom="80" :right="50" container=".main-content"></ABackTop>
      </Content>
    </Layout>
    <Modal v-model="showPastDueWarning" :mask-closable="false" width="360" footer-hide>
      <p slot="header" style="color: #ed4014; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>Account Alert: Billing Issue</span>
      </p>
      <div style="text-align: center">
        <p>There's a problem with your payment.</p>
        <p>Please check and update your payment method if necessary.</p>
        <br />

        <p><Button type="primary" size="large" @click="handleChangePlan">Retry Payment</Button></p>
      </div>
    </Modal>

    <privacy-modal :showDialog="showPrivacy" @cancel="showPrivacy = false"></privacy-modal>
    <terms-modal :showDialog="showTerms" @cancel="showTerms = false"></terms-modal>
    <plan-selector :show="showPlanSelector" :idPrefix="'footer'" @cancel="showPlanSelector = false"></plan-selector>
  </Layout>
</template>
<script>
import User from "./components/user";

import PrivacyModal from "../legal-docs/privacy-modal.vue";
import TermsModal from "../legal-docs/terms-modal.vue";
import Notice from "../notices/notice.vue";
import ABackTop from "./components/a-back-top";
import Fullscreen from "./components/fullscreen";
import Help from "./components/help";
import ErrorStore from "./components/error-store";
import { mapState, mapGetters } from "vuex";

import { on } from "iview/src/utils/dom";
import { dimensionMap } from "iview/src/utils/assist";

import PlanSelector from "../billing/plan-selector.vue";
import TopWarning from "../billing/top-warning.vue";

import moment from "moment";
import "./master.less";

export default {
  name: "Master",
  components: {
    Fullscreen,
    Help,
    ErrorStore,
    User,
    PrivacyModal,
    TermsModal,
    Notice,
    ABackTop,
    PlanSelector,
    TopWarning,
  },
  data() {
    return {
      isCollapsed: false,
      hoverCollapseToggled: false,
      collapsed: false,
      isFullscreen: false,
      showMobileMenu: false,
      showPastDueWarning: false,
      showPlanSelector: false,
      showPrivacy: false,
      showTerms: false,
      mediaMatched: false,
      activeMenuName: "dashboard",
      accountId: window.abp && window.abp.custom.currentBillingAccountId ? window.abp.custom.currentBillingAccountId : 0,
    };
  },
  computed: {
    ...mapState("session", ["billingAccounts", "user"]),
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("billing", ["hasUserManagementPermission", "hasAccountAdminPermission"]),
    billingAccountId: {
      get() {
        return this.accountId;
      },
      set(newValue) {
        if (newValue !== 0) {
          this.accountId = newValue;
          this.$store.dispatch("session/setCurrentBillingAccountId", newValue).then(() => {
            let routeUrl = this.$router.resolve({ name: "dashboard" }).href;
            location.replace(routeUrl);
            location.reload();
            //this.loadAccountInfoAndPricePlans();
          });
        } else {
          this.$router.push({ name: "createBillingAccount" });
        }
      },
    },
    isAccountCreated() {
      let accounts = this.billingAccounts.filter((a) => a.originalOwnerId == this.user.id);
      return accounts.length > 0;
    },
    userAvatar() {
      return this.$store.state.user.avatarImgPath;
    },
    cacheList() {
      return this.$store.state.app.cachePage;
    },
    menuList() {
      return this.$store.getters.menuList;
    },
    local() {
      return this.$store.state.app.local;
    },
    hasReadErrorPage() {
      return this.$store.state.app.hasReadErrorPage;
    },
    unreadCount() {
      return this.$store.state.user.unreadCount;
    },
    rotateIcon() {
      return ["menu-toggler-icon", this.isCollapsed ? "rotate-icon" : ""];
    },
    menuitemClasses: function () {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    },
  },
  watch: {
    $route(newRoute) {
      this.setActiveMenuName(newRoute);

      if (newRoute.name === "dashboard") {
        this.checkPastDue(this.billingAccount, true);
      }
    },
    billingAccount(newValue) {
      this.checkPastDue(newValue, this.$route.name === "dashboard");
    },
  },
  mounted() {
    console.info("master mounted");

    this.setActiveMenuName(this.$route);

    this.loadAccountInfoAndPricePlans();

    on(window, "resize", this.onWindowResize);
    this.matchMedia();

    abp.event.on("abp.notifications.received", this.handleNotificationReceived);
  },
  beforeDestroy() {
    console.log("leave page");
    abp.event.off("abp.notifications.received", this.handleNotificationReceived);
  },
  methods: {
    checkPastDue(billingAccount, isDashboard) {
      if (billingAccount && isDashboard) {
        let isAdmin = billingAccount.grantedPermissions && billingAccount.grantedPermissions.includes("Bio.Adminland");
        this.showPastDueWarning = isAdmin && (billingAccount.status === 2 || billingAccount.status === 4 || billingAccount.status === 5 || billingAccount.status === 6 || billingAccount.status === 7);
      }
    },
    loadAccountInfoAndPricePlans() {
      if (abp.auth.getToken()) {
        this.$store
          .dispatch("billing/getBillingAccountInfo")
          .then((response) => {})
          .finally(() => {});

        this.$store
          .dispatch("billing/getPricePlans")
          .then((response) => {})
          .finally(() => {});
      }
    },
    initSessionInfo() {
      this.$store
        .dispatch("billing/getBillingAccountInfo")
        .then((response) => {})
        .finally(() => {});

      this.$store
        .dispatch("session/init")
        .then((response) => {})
        .finally(() => {});
    },
    handleNotificationReceived(userNotification) {
      console.log(userNotification);
      if (userNotification.notification.entityId === this.billingAccount.id && userNotification.notification.data.version >= 0) {
        //this.initSessionInfo();
        location.reload();
      }
    },
    mouseOver: function () {
      if (this.isCollapsed === true) {
        this.collapsedSider();
        this.hoverCollapseToggled = true;
      }
    },
    mouseLeave: function () {
      if (this.hoverCollapseToggled === true) {
        this.collapsedSider();
        this.hoverCollapseToggled = false;
      }
    },
    handleMenuSelect() {
      //this.$store.dispatch("goal/setActiveMenu", menuId);
    },
    collapsedSider() {
      this.$refs.leftSider.toggleCollapse();
    },
    toggleMobileMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    matchMedia() {
      let matchMedia;
      if (window.matchMedia) {
        matchMedia = window.matchMedia;
      }
      let mediaMatched = this.mediaMatched;
      this.mediaMatched = matchMedia(`(max-width: ${dimensionMap["xl"]})`).matches;

      if (this.mediaMatched !== mediaMatched) {
        if (this.mediaMatched !== this.isCollapsed) {
          //this.$refs.leftSider.toggleCollapse();
        }
      }
    },
    onWindowResize() {
      this.matchMedia();
    },
    setActiveMenuName(route) {
      if (route.name === "goal") {
        this.activeMenuName = "goals";
      } else if (route.name === "review") {
        this.activeMenuName = "reviews";
      } else if (route.name === "project") {
        this.activeMenuName = "projects";
      } else if (route.name === "user") {
        this.activeMenuName = "users";
      } else {
        this.activeMenuName = route.name;
      }
    },
    handleChangePlan() {
      this.showPlanSelector = true;
    },
    handleWithdrawCancellation() {
      let context = this;
      context.$store
        .dispatch("billing/withdrawCancellation")
        .then(() => {
          context.$Notice.success({
            title: "Don't cancel",
            desc: "Success! ",
          });
        })
        .finally(() => {});
    },
  },
};
</script>

<style scoped>
.rotate-icon {
  transform: rotate(-90deg);
}

.left-sider-top {
  height: 45px;
  text-align: center;
  padding: 4px;
}
</style>